import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { ScrollTop } from '@/components/element/ScrollTop';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { TaskSummary } from '@/components/features/tasks/sales_order_contract/TaskSummary';
import { TaskProgress } from '@/components/features/tasks/sales_order_contract/TaskProgress';
import { TaskFiles } from '@/components/features/tasks/sales_order_contract/TaskFiles';
import { Comments } from '@/components/features/tasks/sales_order_contract/Comments';
import { Activities } from '@/components/features/tasks/sales_order_contract/Activities';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { ToDoList } from '@/components/features/tasks/sales_order_contract/ToDoList';
import { ProjectInfo } from '@/components/features/tasks/sales_order_contract/ProjectInfo';

export const ApprovalSalesOrderContractTask = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  const { _w_ } = useCurrentWorkspace();
  useEffect(() => setTitle('Approval - Sales Order Contract Task Detail'), []);
  useEffect(() => setBreadcrumbs([{ label: `Approval`, path: `/w/${_w_!.identifier}/approval` }]), []);

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <div className="container-fluid py-4">
        <div className="row mb-4">
          <div className="col-12 col-lg-7">
            <ToDoList />

            <TaskFiles />

            <Comments />
          </div>
          <div className="col-12 col-lg-5">
            <TaskSummary />

            <TaskProgress />

            <ProjectInfo />

            <Activities />
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
